import { atom } from 'recoil';

export const isEditReceiptModalOpenAtom = atom({
  key: 'isEditReceiptModalOpen',
  default: false,
});
